import { status } from "skin/event/status";
import add from "./add";

const control = (obj, form, story, data, d, action) => {
	// Отключаем добавление товаров для примеров категории
	const _d = JSON.parse(d)
	if (_d.code === "mGoodsEx") return status.ignore;

	switch (obj.action) {
		case "add":
			return add(obj, form, story, data, d, action);
		default:
	}
	return status.action;
};

export default control;
